<template>
  <div></div>
</template>
<script>
// @ is an alias to /src


export default {
  name: 'LandingView',
  components: {
  },
  data() {
    return { }
  },
  methods: {
    detectIsScrolledLanding() {
      let isScrolledThreshold = window.innerHeight * 0.8
      if (window.scrollY > isScrolledThreshold) {
        this.$store.commit('setPlayerDisplay', 'default')
        this.$store.commit('closeBoxPlaylistLanding')
        this.$store.commit('closeBoxProgramLanding')
      } else {
        this.$store.commit('setPlayerDisplay', 'full')
      }
    },
  },
  created() {
    /* Is Scrolled Landing Detection */
    window.addEventListener('scroll', this.detectIsScrolledLanding);
    this.detectIsScrolledLanding();
  }
}
</script>
<style scoped>
section {
  padding: 0;
}
</style>
